var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.refleshKey,attrs:{"id":"app"}},[_c('apexchart',{attrs:{"options":_vm.chartOptions,"series":_vm.series,"type":"bar","height":"200","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }